"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../assets/styles/config");
exports.StyledContainer = styled_components_1.default.div `
  background: ${config_1.colors.midnight};
  height: 100%;
  overflow: auto;
`;
